import React from 'react';
import Modal from '~ComponentsImproved/Modal';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import { useButton, useI18n } from '~Hooks';
import { Box, Button, BlueButton } from '~Styles';

export interface Props {
  question: string;
  isShowing: boolean;
  onLeftClick: () => void;
  onRightClick: () => void;
  leftText?: string;
  rightText?: string;
  width?: string;
  backdropClose?: () => void;
  icon?: string;
}

const QuestionModal: React.FunctionComponent<Props> = ({
  question,
  isShowing,
  onLeftClick,
  onRightClick,
  leftText,
  rightText,
  width = '512px',
  backdropClose,
  icon,
}) => {
  const { i18n } = useI18n();
  const isHandy = window.innerWidth <= 600;

  const leftButton = useButton({
    onClick: onLeftClick,
  });

  const rightButton = useButton({
    onClick: onRightClick,
  });

  return (
    <Modal isShowing={isShowing} backdropClose={Boolean(backdropClose)} hide={backdropClose}>
      <ModalWrapper
        padding={isHandy ? 'large' : '3xl'}
        width={width}
        gap="small"
        header={{
          icon,
          title: question,
        }}>
        <Box fluid display="flex" gap="xs" marginTop="small">
          <Button fluid {...leftButton}>
            {leftText ?? i18n('General.No')}
          </Button>
          <BlueButton fluid {...rightButton}>
            {rightText ?? i18n('General.Yes')}
          </BlueButton>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default QuestionModal;
